import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { agylePref, preferencesLoaded } from '../store/reducers/preferences';
import { isCentralPageModuleEnabled } from '../pages/centralPage/helper';
import { CENTRAL_PAGE_PATH } from '../pages/centralPage/constants';

export default function useAgyleRedirect() {
    const agylePreference = useSelector(agylePref);

    const history = useHistory();
    const location = useLocation();
    const userDataLoaded = useSelector(preferencesLoaded);

    const [redirect, setRedirect] = useState('/');

    useEffect(() => {
        if (!userDataLoaded) return;

        let redirect = '';
        if (isCentralPageModuleEnabled) {
            if (agylePreference?.defaultStartingPage && agylePreference?.defaultStartingPage.at(0) === '/')
                redirect = agylePreference?.defaultStartingPage;
            else redirect = CENTRAL_PAGE_PATH;
        } else {
            redirect = '/wards';
        }

        // Redirect to last visited page after refresh
        if (location?.pathname && location?.pathname !== '/') {
            redirect = `${location?.pathname}${location.search.length > 0 ? location.search : ''}`;
        }

        if (redirect.at(0) === '/') {
            setRedirect(redirect);
            if (process.env.BUILD_MODULE === 'agyle') {
                history.push(redirect);
            }
        }
    }, [isCentralPageModuleEnabled, agylePreference?.defaultStartingPage, userDataLoaded]);

    return redirect;
}
